/**
 * Chatbot QA — reporting-service (`/api/v1/reporting/qa-analysis/*`).
 * Bearer + X-Workspace-Id via reportingApiFetch only (see docs/SECURITY.md).
 */

import { reportingApiFetch, reportingPath } from "@/lib/reportingApi";
import { ReportingAnalyticsDateRange } from "@/pages/analytics/lib/reportingAnalyticsDateRange";

export class BotReportingQaApiClient {
  /**
   * @param {{ startDate: string, endDate: string }} range
   * @param {RequestInit} [init]
   */
  getQaAnalysis(range, init = {}) {
    const w = new ReportingAnalyticsDateRange(range);
    return reportingApiFetch(`${reportingPath("/qa-analysis")}${w.toWindowQueryString()}`, init);
  }

  /**
   * @param {{ startDate: string, endDate: string }} range
   * @param {RequestInit} [init]
   */
  getQaScorePercentages(range, init = {}) {
    const w = new ReportingAnalyticsDateRange(range);
    return reportingApiFetch(`${reportingPath("/qa-analysis/score-percentages")}${w.toWindowQueryString()}`, init);
  }

  /**
   * @param {{ limit: number, days: number }} body
   * @param {RequestInit} [init]
   */
  async runQaAnalysis(body, init = {}) {
    const res = await reportingApiFetch(reportingPath("/qa-analysis/run"), {
      ...init,
      method: "POST",
      body: JSON.stringify(body),
    });
    return res;
  }

  /**
   * @param {string} jobId
   * @param {RequestInit} [init]
   */
  getQaJobStatus(jobId, init = {}) {
    return reportingApiFetch(`${reportingPath(`/qa-analysis/jobs/${encodeURIComponent(jobId)}`)}`, init);
  }
}

export const botReportingQaApiClient = new BotReportingQaApiClient();
